import { Button } from "@/components/ui/button";
import { CirclePlus } from "lucide-react";
import { memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { generatePath, useNavigate } from "react-router-dom";
import { PATH_PROJECT_RATE_NEW } from "@/constants";
import { useProjectId } from "@/modules/projects/hooks/useProjectId";
import { useModulePermissions } from "@/modules/account/hooks/useModulePermissions";
import { useCheckIsProjectLocked } from "../../hooks/useCheckIsProjectLocked";

const ProjectRateAddButtonComponent = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const projectId = useProjectId();
  const { can_update } = useModulePermissions();
  const isProjectLocked = useCheckIsProjectLocked();

  const onAddRole = useCallback(() => {
    navigate(
      generatePath(PATH_PROJECT_RATE_NEW, {
        projectId,
      }),
    );
  }, [navigate, projectId]);

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onAddRole}
      key="edit"
      disabled={!can_update || isProjectLocked}
    >
      <CirclePlus className="w-5 h-5 mr-1" />
      {t("projectRates.buttons.add")}
    </Button>
  );
};

export const ProjectRateAddButton = memo(ProjectRateAddButtonComponent);
